module.exports = __webpack_public_path__ + "static/media/glucometer.a68df015.jpg";